export default __webpack_public_path__ + "static/media/delete.155c170d.svg";